import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selector = (state: RootState) => state.snowflakeTestConnection;

const snowflakeTestConnectionData = createSelector([selector], (state) => state);

export default {
  snowflakeTestConnectionData
};